// extracted by mini-css-extract-plugin
export default {"item":"index_item__vGD0p","row":"index_row__QfX-s","draggable":"index_draggable__X0lns","icon":"index_icon__ezUcq","content":"index_content__tZzny","label":"index_label__uFYN4"};